import { ALL_MONTHS } from "../constants";
import { Card, ST } from "../ui/SharedUI";

export default function Settings({startMonth, onChangeStartMonth, companyName, onChangeCompanyName}) {
  return (
    <div style={{display:"flex",flexDirection:"column",gap:"16px"}}>
      <Card>
        <ST>会社名設定</ST>
        <div style={{fontSize:"12px",color:"#555",marginBottom:"12px",fontFamily:"'Noto Sans JP',sans-serif"}}>右上に表示される会社名を設定します</div>
        <input
          value={companyName}
          onChange={e=>onChangeCompanyName(e.target.value)}
          placeholder="会社名を入力"
          style={{fontSize:"14px",fontWeight:"700",border:"1px solid #D0D8D0",borderRadius:"6px",padding:"8px 12px",width:"240px",fontFamily:"'Noto Sans JP',sans-serif",color:"#1A3A1A"}}
        />
      </Card>
      <Card>
        <ST>会計期間設定</ST>
        <div style={{fontSize:"12px",color:"#555",marginBottom:"12px",fontFamily:"'Noto Sans JP',sans-serif"}}>決算月を選択してください（翌月が期首になります）</div>
        <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
          {ALL_MONTHS.map((m,i)=>{
            const start = (i+1)%12+1;
            const isActive = startMonth===start;
            return (
              <button key={m} onClick={()=>onChangeStartMonth(start)}
                style={{padding:"7px 14px",background:isActive?"#2D7A2D":"#F0F4F0",color:isActive?"#fff":"#555",border:isActive?"1px solid #2D7A2D":"1px solid #D8E0D8",borderRadius:"4px",cursor:"pointer",fontSize:"12px",fontFamily:"'Noto Sans JP',sans-serif",fontWeight:isActive?"700":"400"}}>
                {m}決算
              </button>
            );
          })}
        </div>
        <div style={{marginTop:"16px",padding:"12px",background:"#F5FAF5",borderRadius:"6px",fontSize:"12px",color:"#555",fontFamily:"'Noto Sans JP',sans-serif"}}>
          現在の設定：<strong style={{color:"#2D7A2D"}}>{ALL_MONTHS[(startMonth+10)%12]}決算</strong>（期首：{ALL_MONTHS[startMonth-1]}）
        </div>
      </Card>
    </div>
  );
}
